import { EventsParam } from '../../api/events';
import { Trend } from '../../interfaces/trends';
import { trends } from '../../api/trends';

async function fetchTrends(params: EventsParam): Promise<Trend[]> {
	try {
		return await trends.getTrends(params);
	} catch (error) {
		throw error;
	}
}

export const trendsService = {
	fetchTrends,
};
